import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeStudentTableData,
//   ChangeTrainerSearchText,
// } from "../../../actions/adminAction";
// import { GetTestTableData } from "../../../actions/traineeAction";
// import { ChangeAssignTestModalState } from "../../../actions/trainerAction";
import { useNavigate } from "react-router-dom"; // for React Router v6
import DashboardWrapper from "../shared/DashboardWrapper";
import { Col, Divider, Row, Spin, Typography } from "antd";
import "./badges.css";
import BadgeGold from "../../../assets/badgeGold.svg";
import BadgeGrey from "../../../assets/badgeGrey.svg";
import Diamond from "../../../assets/diamond.svg";
import {retriveToken,fetchAuth} from "../../../services/AuthServices";
import { SecureGet, SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import { login } from "../../../reducers/loggedinuser";

const formatDate = (date) => {
  if (date) {
    const dateObj = new Date(date);
    return `${dateObj.getUTCMonth() + 1}/${dateObj.getUTCDate()}/${dateObj.getUTCFullYear()}`;
  }
  return ""; 
};

const Badges = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [badgesData, setBadgesData] = useState([]);
  const [rewardbadgesData, setRewardBadgesData] = useState();
  
  const dispatch = useDispatch(); // Replaces `connect`
  const navigate = useNavigate(); // Replaces `withRouter`
  
  const auth = useSelector((state) => state.auth); // Accessing Redux store directly

  useEffect(() => {
    const fetchData = async () => {
      const token = retriveToken();
      if (token && token !== "undefined") {
        try {
          const badgesResponse = await SecureGet({
            url: apis.GET_BADGES,
            params: { Token: token },
          });
          const rewardBadgesResponse = await SecurePost({
            url: apis.GET_REWARD_BADGE,
            params: { Token: token },
          });

          setBadgesData(badgesResponse?.data?.data || []);
          setRewardBadgesData(rewardBadgesResponse?.data);
        } catch (error) {
          console.error("Error fetching badges data:", error);
        } finally {
          setIsLoading(false);
        }

        // Fetching user details after the token validation
        const userResponse = await fetchAuth(token);
        dispatch(login(userResponse.data.user)); // Dispatch login action
      } else {
        navigate("/"); // Redirect to login if token is not available
      }
    };

    fetchData();
  }, [dispatch, navigate]);

  return (
    <DashboardWrapper title="MY BADGES">
      <Divider className="divier_edit" />
      <div className="badgeParrent_wrapper">
        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40vh" }}>
            <Spin size="large" />
          </div>
        ) : (
          <>
            <Typography className="badgeLengthText">
              {auth?.user.badgesIds?.length} of {badgesData?.length} badges
            </Typography>
            <div className="badgeWrapper">
              <Row gutter={[16, 24]}>
                {badgesData.map((item) => {
                  const isBadgeFind = auth?.user.badgesIds?.find((obj) => obj?.badgeId === item._id);
                  return (
                    <Col key={item._id} className="gutter-row" xs={24} md={8} lg={6}>
                      <div className="badge">
                        <img
                          width={"100px"}
                          src={isBadgeFind ? BadgeGold : BadgeGrey}
                          alt={item?.name}
                        />
                        <Typography className="badgeTitle">{item?.name}</Typography>
                        <Typography style={{ fontSize: "14px", fontWeight: "400" }} className="badgeDesc">
                          {isBadgeFind ? `Attained: ${formatDate(isBadgeFind?.attainedAt)}` : ""}
                        </Typography>
                        <div className="badgeHoverBox">
                          <Typography className="badgeTitle" style={{ textAlign: "center" }}>
                            {item?.name}
                          </Typography>
                          <div>
                            <Typography className="badgeDesc">{item.criteria1}</Typography>
                            <Typography className="badgeDesc">{item.criteria2}</Typography>
                          </div>
                          <Typography className="badgeDesc">
                            Reward: <img width={"18px"} src={Diamond} alt="diamond" />{" "}
                            {parseInt(item?.reward || 0)?.toLocaleString()} points
                          </Typography>
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </>
        )}
      </div>
    </DashboardWrapper>
  );
};

export default Badges;
